import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContexte';
import { useAccess } from '../../contexts/AccessContext';
import { OWNER_ID } from '../../config/permissions';
import Icon from '../ui/Icon';

// Bouton flottant, visible sur tout le site, réservé au propriétaire et aux Administrateurs Site
const SuperAdminButton = () => {
    const { user } = useAuth();
    const { isSiteAdmin } = useAccess();
    const location = useLocation();

    // Affichage immédiat pour le propriétaire, en attendant la réponse du serveur
    const shouldShow = isSiteAdmin || (!!user && user.id === OWNER_ID);

    if (!shouldShow || location.pathname.startsWith('/admin')) return null;

    return (
        <Link to="/admin" className="c2-admin-fab">
            <Icon name="settings" size={18} />
            Admin
        </Link>
    );
};

export default SuperAdminButton;
